<template>
  <div class="viewEntry">
    <el-row
        v-if="tableData"
        :gutter="24"
        class="tableData"
        style="margin-bottom:20px;position:relative"
    >
      <el-col :lg="4" :md="4" :sm="6" :xs="10">
        <el-button plain type="danger" @click="download">下载报名信息</el-button>
      </el-col>
      <el-col :lg="3" :md="4" :sm="6" :xs="8">
        <el-button :disabled="completeBatch" type="danger" @click="goToTest(1)">批量报名</el-button>
      </el-col>
      <el-col :lg="3" :md="4" :sm="6" :xs="8">
        <el-button :disabled="completeBatch" plain type="success" @click="goToTest(2)">测试编排</el-button>
      </el-col>
      <el-col :lg="3" :md="4" :sm="6" :xs="8">
        <el-button type="success" @click="chooseApprove">视频录像</el-button>
      </el-col>
      <el-col :lg="3" :md="3" :sm="6" :xs="8">
        <el-button :disabled="completeArrange" plain type="primary" @click="importResult">成绩录入</el-button>
      </el-col>
      <!--<el-col :xs="8" :sm="6" :md="3" :lg="3">
        <el-button type="primary" :disabled="completeArrange" plain @click="ScoreListResult">查看成绩</el-button>
      </el-col>-->
      <!-- <el-col :xs="12" :sm="8" :md="5" :lg="4">
        <el-button type="primary" :disabled="completeImport" @click="batchRecordOperate">批量申请证书证章</el-button>
      </el-col> -->
      <el-col :lg="2" :md="3" :sm="4" :xs="8">
        <el-button class="returnPage" plain type="danger" @click="goBack()">返 回</el-button>
      </el-col>
    </el-row>
    <div style="color:#409EFF;font-size:14px;margin:10px 0 15px 0">
      <span style="margin-right:28px;">成绩判定状态:{{ grade_submission_status }}</span>
      <span v-if="grade_submission_status=='已驳回'">成绩驳回理由:{{ grade_submission_msg }}</span>
    </div>
    <el-radio-group v-model="radio" style="margin: 15px 0" @change="chooseChange">
      +
      <el-radio :label="1">报名信息</el-radio>
      <el-radio :label="2">编排信息</el-radio>
      <!--<el-radio :label="3">证书证章信息</el-radio>-->
      <el-radio :label="4">查看成绩</el-radio>
      <el-radio :label="5">补考信息</el-radio>
    </el-radio-group>

    <el-table v-loading="loading" :data="tableData" :row-class-name="tableRowClassName" style="width: 100%">
      <el-table-column :index="getIndex" label="序号" type="index" width="80"></el-table-column>
      <el-table-column align="center" label="姓名" prop="name"></el-table-column>
      <el-table-column v-if="signUp" key="sex" align="center" label="性别" prop="xing_bie"></el-table-column>
      <el-table-column v-if="signUp || searchScore" key="certificates_number" align="center" label="证件号码"
                       prop="certificates_number"></el-table-column>
      <el-table-column v-if="signUp" key="grade" align="center" label="测试等级" prop="grade"></el-table-column>
      <!--<el-table-column prop="arrange_number" label="序号" align="center" v-if="choreography"></el-table-column>-->
      <el-table-column v-if="showRetake" key="grade" align="center" label="测试班级" prop="test_class_title"></el-table-column>
      <el-table-column v-if="signUp" align="center" label="退费状态" prop="refund_status">
        <template slot-scope="scope">
          {{
            scope.row.refund_status === 0 ? '未退费' : scope.row.refund_status === 1 ? '退费中' : scope.row.refund_status === 2 ? '退费成功' : '退费失败'
          }}
        </template>
      </el-table-column>
      <el-table-column v-if="choreography" key="arrange_group" align="center" label="组号"
                       prop="arrange_group"></el-table-column>
      <el-table-column v-if="choreography" key="arrange_time" cealign="center" label="预计测试时间"
                       prop="arrange_time"></el-table-column>
      <el-table-column v-if="certificate" key="application_method" align="center" label="申请方式"
                       prop="application_method"></el-table-column>
      <el-table-column v-if="searchScore" key="subject_1" align="center" label="科目一"
                       prop="subject_1"></el-table-column>
      <el-table-column v-if="searchScore" key="subject_2" align="center" label="科目二"
                       prop="subject_2"></el-table-column>
      <el-table-column v-if="searchScore" key="subject_3" align="center" label="科目三"
                       prop="subject_3"></el-table-column>
      <el-table-column v-if="searchScore" key="subject_4" align="center" label="科目四"
                       prop="subject_4"></el-table-column>
      <el-table-column v-if="signUp && currentTab != 5" key="operate" align="center"
                       fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.refund_status === 0 && (applyRefundStatus === 0 || applyRefundStatus === 3)" size="small" type="text"
                     @click="handleAddRefund(scope.row)">
            退费
          </el-button>
          <el-button v-if="scope.row.refund_status === 1" size="small" type="text"
                     @click="handleAddRefund(scope.row)">
            取消退费
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination" style="text-align: center;margin-top:30px">
      <el-pagination
          v-if="totalCount>10"
          :page-size="paging.limit"
          :total="totalCount"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog
        :visible.sync="dialogTableVisible"
        :width="screenWidth>768? '40%' :'90%'"
        class="batchApplication"
        title="批量申请证书证章"
    >
      <el-dialog
          :visible.sync="addressVisible"
          :width="screenWidth>768? '20%' :'60%'"
          append-to-body
          title="提示"
      >
        <span>友情提示，证书证章会邮寄到您的机构地址。</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitAddress">确 定</el-button>
        </span>
      </el-dialog>
      <el-button
          v-show="batchButton"
          :disabled="batchShow"
          type="primary"
          @click="confirmApplication"
      >批量申请
      </el-button>
      <el-button v-show="!batchButton" style="margin-left:0" type="primary" @click="payPost">去缴费</el-button>
      <p v-if="!batchShow" style="color:red;margin: 15px 0 10px 0;line-height:22px">
        申请全部人员的证书证章
        <br/>批量申请只需缴纳快递费
      </p>
      <p v-if="batchShow" style="color:red;margin: 15px 0 10px 0;">已批量申请过证书证章</p>
      <el-table :data="gridData" style="max-height: 300px;overflow: auto;">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="姓名" property="name" width="100"></el-table-column>
        <el-table-column label="证件类型" property="certificates_type"></el-table-column>
        <el-table-column label="证件号码" property="certificates_number"></el-table-column>
        <el-table-column label="等级" property="certificate_grade"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVideoVisible"
        :width="dialogVideoVisibleWidth"
        class="dialogVideo"
        title="视频录像"
    >
      <el-form ref="videoForm" :model="videoForm" :rules="rulesUrl">
        <el-form-item label="视频录像：" label-width="100px" prop="video_url">
          <!--<el-input v-model="videoForm.name" autocomplete="off"序号></el-input>-->
          <el-input v-model="videoForm.video_url" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVideoVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUrl('videoForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!--查看成绩  XXL 2021年5月26日 11:22:25-->
    <div v-if="scoreShow" class="scoreDiv" style="">
      <div class="scoreDivHead" style=" ">
        <div class="scoreDivHeadClose" style="" @click="colseButton">关闭</div>
      </div>
      <div class="scoreDivCon">
        <el-table :data="tableDataSoce" style="width: 100%">
          <el-table-column :index="getIndexScore" label="序号" type="index" width="80"></el-table-column>
          <el-table-column align="center" label="姓名" prop="name"></el-table-column>
          <el-table-column align="center" label="性别" prop="sex"></el-table-column>
          <el-table-column label="证件号码" prop="certificates_number"></el-table-column>
          <el-table-column align="center" label="科目一" prop="subject_1"></el-table-column>
          <el-table-column align="center" label="科目二" prop="subject_2"></el-table-column>
          <el-table-column align="center" label="科目三" prop="subject_3"></el-table-column>
          <el-table-column align="center" label="科目四" prop="subject_4"></el-table-column>
        </el-table>
        <div class="pagination" style="text-align: center;margin-top:30px">
          <el-pagination
              v-if="totalCountSoce>10"
              :page-size="pagingSoce.limit"
              :total="totalCountSoce"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChangeSoce"
          ></el-pagination>
        </div>
      </div>

    </div>

  </div>
</template>
<style>
.scoreDiv {
  width: 50%;
  height: 750px;
  position: fixed;
  background-color: #FFFFFF;
  top: 10%;
  z-index: 9999;
}

.scoreDivHead {
  position: relative;
  text-align: right;
  background-color: #FBFDFF;
  width: 100%;
  height: 30px;
}

.scoreDivHeadClose {
  position: absolute;
  line-height: 30px;
  right: 20px;
  cursor: pointer;
}

.scoreDivCon {
  width: 90%;
  height: 700px;
  overflow-y: auto;
  margin: 0 auto;
}
</style>
<script>
import {mapGetters} from "vuex";
import {
  GetAthleteTestApplication,
  AthleteTestRegistration,
  GetBulkApplyCertificatePerson,
  TestVideoData,
  CreatePaperCertificate,
  GetAthleteTestApplicationScore, saveRefund
} from "@/api/admin/test.js";
import {GetRetakeApplicationList} from "../../../../api/admin/test";

export default {
  computed: {
    ...mapGetters(["screenWidth"])
  },
  data() {
    return {
      tableData: [],
      tableDataSoce: [],
      downloadhttp: "",
      gridData: [],
      dialogTableVisible: false,
      addressVisible: false,
      batchButton: true,
      paging: {
        limit: 10,
        page: 1
      },
      pagingSoce: {
        limit: 10,
        page: 1
      },
      totalCount: "",
      totalCountSoce: "",
      testId: {},
      importResults2: true,
      signUp: true,
      choreography: false,
      certificate: false,
      radio: 1,
      completeArrange: true,
      completeImport: true,
      completeBatch: false,
      dialogVideoVisible: false,
      rulesUrl: {
        video_url: [
          {required: true, message: "请填写视频地址", trigger: "blur"}
        ]
      },
      videoForm: {
        video_url: ""
      },
      grade_submission_status: "",
      grade_submission_msg: "",
      dialogVideoVisibleWidth: "35%",
      batchShow: false,
      scoreShow: false,
      imgPath: window.apiObj.apiUrl,
      searchScore: false,
      currentTab: 1,
      currentPage: 1,
      loading: false,
      applyRefundStatus: false,
      showRetake: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.refund_status === 1) {
        return 'warning-row';
      }
      return '';
    },
    // 表格索引
    getIndex(index) {
      let curpage = this.paging.page; //当前页码
      let limitpage = this.paging.limit; //每页条数
      return index + 1 + (curpage - 1) * limitpage;
    },
    getIndexScore(index) {
      let curpage = this.pagingSoce.page; //当前页码
      let limitpage = this.pagingSoce.limit; //每页条数
      return index + 1 + (curpage - 1) * limitpage;

    },
    getList() {
      this.testId.test_apply_id = this.$route.query.id;
      this.testId.test_class_id = this.$route.query.id;
      this.testId.application_status = this.$route.query.application_status;
      this.paging.type = 1;
      GetAthleteTestApplication(Object.assign(this.paging, this.testId)).then(
          data => {
            var list = data.data.result;

            if (list) {
              this.tableData = list.items;
              this.totalCount = list.totalCount;
              this.grade_submission_status = list.grade_submission_status;
              this.grade_submission_msg = list.grade_submission_msg;
              this.applyRefundStatus = list.refund_status
              if (this.grade_submission_status != "未提交") {
                this.completeBatch = true;
              }
              if (this.tableData.length > 0) {
                if (this.tableData[0].hasOwnProperty("arrange_group")) {
                  this.completeArrange = false;
                  if (this.tableData[0].hasOwnProperty("certificate_numbering")) {
                    this.completeImport = false;
                  }
                }
              }
            }
          }
      );
    },
    //格式化日期
    formatDate(row) {
      let moment = require("moment");
      return moment(row.creationTime).format("YYYY-MM-DD HH:mm:ss");
    },
    //表格数据筛选
    chooseChange(val) {
      this.currentTab = val;
      if (val == 1) {
        this.signUp = true;
        this.choreography = false;
        this.certificate = false;
        this.searchScore = false;
        this.showRetake = false;
      } else if (val == 2) {
        this.signUp = false;
        this.choreography = true;
        this.certificate = false;
        this.searchScore = false;
        this.showRetake = false;
      } else if (val == 3) {
        this.signUp = false;
        this.choreography = false;
        this.certificate = true;
        this.searchScore = false;
        this.showRetake = false;
      }else if (val == 5) {
        this.signUp = true;
        this.choreography = false;
        this.certificate = false;
        this.searchScore = false;
        this.showRetake = true;
      } else {
        this.signUp = false;
        this.choreography = false;
        this.certificate = false;
        this.searchScore = true;
        this.showRetake = false;
      }
      this.handleCurrentChange(this.currentPage);
    },
    //下载报名信息
    download() {
      AthleteTestRegistration(Object.assign(this.testId)).then(data => {
        var list = data.data.result;
        if (list) {
          if (!list.isSuccess) {
            this.$message.error(list.errorMsg);
          }
          var elemIF = document.createElement("iframe");
          elemIF.src = this.imgPath + list.filePath;
          elemIF.style.display = "none";
          document.body.appendChild(elemIF);
        } else {
          this.$message.error("下载失败");
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
          .then(() => {
            done();
          })
          .catch(() => {
          });
    },
    handleClick(row) {
      //window.console.log(row);
    },
    // 导入成绩
    importResult() {
      this.$router.push({
        path: "/personal/testList/viewEntry/testScheduling",
        query: {id: 3, test_class_id: this.testId.test_class_id}
      });
    },
    // 查看成绩  XXL 2021年5月26日 11:35:45
    colseButton() {
      this.scoreShow = false;
    },
    handleCurrentChangeSoce(cpage) {
      this.testId.test_apply_id = this.$route.query.id;
      this.testId.test_class_id = this.$route.query.id;
      this.pagingSoce.page = cpage;
      GetAthleteTestApplicationScore(Object.assign(this.pagingSoce, this.testId)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tableDataSoce = list.items;
          this.totalCountSoce = list.totalCount;
        }
      });

    },
    ScoreListResult() {
      this.scoreShow = true;
      this.testId.test_apply_id = this.$route.query.id;
      this.testId.test_class_id = this.$route.query.id;
      this.testId.application_status = this.$route.query.application_status;

      GetAthleteTestApplicationScore(Object.assign(this.paging, this.testId)).then(
          data => {
            var list = data.data.result;
            if (list) {
              this.tableDataSoce = list.items;
              this.totalCountSoce = list.totalCount;
              if (this.grade_submission_status != "未提交") {
                this.completeBatch = true;
              }
              if (this.tableDataSoce.length > 0) {
                if (this.tableDataSoce[0].hasOwnProperty("arrange_group")) {
                  this.completeArrange = false;
                  if (this.tableDataSoce[0].hasOwnProperty("certificate_numbering")) {
                    this.completeImport = false;
                  }
                }
              }
            }
          }
      );
    },
    //批量申请证书证章
    batchRecordOperate() {
      // this.dialogTableVisible = true;
      GetBulkApplyCertificatePerson(Object.assign(this.testId)).then(data => {
        var list = data.data.result;
        if (list.totalCount == 0) {
          this.$message({
            message: "当前的测试班暂无人员可进行批量申请",
            type: "warning"
          });
        } else if (list.isMoreServenDays == false) {
          this.$message({
            message: "发布成绩还没有超过7天，请稍候再进行申请",
            type: "warning"
          });
        } else if (list.isMoreServenDays && list.totalCount > 0) {
          this.dialogTableVisible = true;
          this.gridData = list.items;
          if (list.isAllowApply) {
            this.batchShow = false;
          } else {
            this.batchShow = true;
          }
        }
      });
    },
    //地址弹窗
    confirmApplication() {
      this.addressVisible = true;
    },
    // 提交批量申请订单
    submitAddress() {
      this.addressVisible = false;
      this.batchButton = false;
      CreatePaperCertificate(Object.assign(this.testId)).then(data => {
        var list = data.data.result;
        if (list) {
          this.$message({
            message: "批量申请证书证章成功",
            type: "success"
          });
        }
      });
    },
    payPost() {
      this.$message({
        message: "请前往订单中心进行缴费",
        type: "success"
      });
      this.dialogTableVisible = false;
    },
    chooseApprove() {
      if (this.testId.application_status == "审批通过") {
        if (this.screenWidth < 1024) {
          this.dialogVideoVisibleWidth = "60%";
        }
        if (this.screenWidth < 768) {
          this.dialogVideoVisibleWidth = "90%";
        }
        this.dialogVideoVisible = true;
      } else {
        this.$message({
          message: "您的审核还未通过,不能上传视频",
          type: "warning"
        });
      }
    },
    //视频地址弹窗
    submitUrl(videoForm) {
      this.dialogVideoVisible = false;
      this.$refs[videoForm].validate(valid => {
        if (valid) {
          TestVideoData(Object.assign(this.testId, this.videoForm)).then(
              data => {
                let list = data.data.result;
                if (list) {
                  this.$message({
                    message: "视频提交成功",
                    type: "success"
                  });
                }
              }
          );
        } else {
          return false;
        }
      });
    },
    //列表分页
    // 分页
    handleCurrentChange(cpage) {
      this.loading = true;
      this.currentPage = cpage;
      if (this.currentTab == 4) {
        this.testId.test_apply_id = this.$route.query.id;
        this.testId.test_class_id = this.$route.query.id;
        this.testId.application_status = this.$route.query.application_status;
        this.paging.page = cpage;
        GetAthleteTestApplicationScore(Object.assign(this.paging, this.testId)).then(data => {
          var list = data.data.result;
          if (list) {
            this.tableData = list.items;
            this.totalCount = list.totalCount;
          }
          this.loading = false;
        });
      } else if (this.currentTab == 5) {
        this.paging.page = cpage;
        GetRetakeApplicationList(Object.assign(this.paging)).then(data => {
          var list = data.data.result;
          if (list) {
            this.tableData = list.items;
            this.totalCount = list.totalCount;
          }
          this.loading = false;
        });
      } else {
        this.paging.page = cpage;
        this.paging.type = this.currentTab;
        GetAthleteTestApplication(Object.assign(this.paging)).then(data => {
          var list = data.data.result;
          if (list) {
            this.tableData = list.items;
            this.totalCount = list.totalCount;
          }
          this.loading = false;
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goToTest(id) {
      this.$router.push({
        path: '/personal/testList/viewEntry/testScheduling',
        query: {id: id, test_class_id: this.testId.test_class_id}
      })
    },
    handleAddRefund(row) {
      const msg = row.refund_status === 0 ? '退费' : '取消退费'
      const status = row.refund_status === 0 ? 1 : 0
      let data = {application_id: row.application_id, status: status}
      this.$confirm('是否确认' + msg + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        saveRefund(data).then(res => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
          this.getList();
        })
      }).catch(() => {
      });
    },
  }
};
</script>

<style lang="less" scoped>
.viewEntry {
  .tableData {
    padding-top: 10px;

    .el-col {
      padding: 0 6px !important;

      button {
        width: 100%;
      }

      @media screen and(max-width: 768px) {
        button {
          margin-top: 12px;
        }
      }
    }

    @media screen and(max-width: 1024px) {
      .returnPage {
        margin-top: 10px;
      }
    }
  }

  .download:hover {
    color: #ffffff;
  }

  .batchRecord {
    ul {
      margin: 10px 0;

      div {
        line-height: 24px;
      }
    }
  }
}
</style>
<style lang="less">
.batchApplication {
  .el-dialog__body {
    padding: 15px 20px 30px 20px;
  }
}

.dialogVideo {
  .el-dialog__body {
    padding: 15px 20px 5px 20px;

    .el-form {
      .el-form-item__content {
        .el-textarea__inner {
          height: 100px;
        }
      }
    }
  }
}

@media screen and(max-width: 768px) {
  .viewEntry {
    .el-radio-group {
      margin: 0;

      label {
        display: block;
        line-height: 28px;
      }
    }
  }
}

.el-table .warning-row {
  background: oldlace;
}
</style>
